import React, { useState } from 'react';
import { message } from 'antd';
import { openTenantLoginPage } from '@crm/utils/tenantUtils';
import '@crm/components/Shared/TenantSwitcher.css';

const TENANTS = [
  { id: 'grh', name: 'GRH', icon: '👥' },
  { id: 'callcenter', name: 'CallCenter', icon: '📞' },
  { id: 'comercial', name: 'Comercial', icon: '💼' },
  { id: 'backoffice', name: 'BackOffice', icon: '📋' },
  { id: 'ccc', name: 'CallCenter Comercial', icon: '🔄' },
];

interface CccTenantSwitcherProps {
  isAdmin: boolean;
}

/** Admin pill — opens each CRM at its login page (no shared session). */
const CccTenantSwitcher: React.FC<CccTenantSwitcherProps> = ({ isAdmin }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [switching, setSwitching] = useState(false);

  if (!isAdmin) return null;

  const current = TENANTS.find((t) => t.id === 'ccc');

  const handleTenantChange = (tenantId: string) => {
    if (tenantId === 'ccc') {
      setIsOpen(false);
      return;
    }

    setSwitching(true);
    setIsOpen(false);
    const opened = openTenantLoginPage(tenantId);
    if (!opened) {
      setSwitching(false);
      message.error('Não foi possível abrir esse departamento.');
    }
  };

  return (
    <div className="tenant-switcher">
      <button
        type="button"
        className="tenant-switcher-btn"
        onClick={() => setIsOpen(!isOpen)}
        disabled={switching}
      >
        <span className="tenant-icon">{current?.icon}</span>
        <span className="tenant-name">{current?.name}</span>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <div className="tenant-dropdown">
          {TENANTS.map((tenant) => (
            <button
              key={tenant.id}
              type="button"
              className={`tenant-option ${tenant.id === 'ccc' ? 'active' : ''}`}
              onClick={() => handleTenantChange(tenant.id)}
              disabled={switching}
            >
              <span className="tenant-option-icon">{tenant.icon}</span>
              <span className="tenant-option-name">{tenant.name}</span>
              {tenant.id === 'ccc' && <span className="current-indicator">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CccTenantSwitcher;
